import React, { memo } from 'react'

import InfoButton from './InfoButton'

const LabelWithInfo = ({ label, message, alignment = 'end' }) => {
  return (
    <div className='label-with-info'>
      {label}
      <InfoButton message={message} alignment={alignment} />
    </div>
  )
}

export default memo(LabelWithInfo)
